import axios from 'axios';
import { Globals } from '../../modules/Globals';
import {
  IReportingCategory,
  IReportingCategoryInput,
} from '../../interfaces/IReportingCategory';

function apiUrl(restaurantId: number) {
  return `${Globals.apiPath}/restaurants/${restaurantId}/reporting-categories`;
}

export default class ReportingCategoriesService {
  static async getAll(restaurantId: number): Promise<IReportingCategory[]> {
    const res = await axios.get<IReportingCategory[]>(apiUrl(restaurantId));
    return res.data;
  }

  static async create(
    restaurantId: number,
    input: IReportingCategoryInput
  ): Promise<IReportingCategory> {
    const res = await axios.post<IReportingCategory>(
      apiUrl(restaurantId),
      input
    );
    return res.data;
  }

  static async update(
    restaurantId: number,
    id: number,
    input: Partial<IReportingCategoryInput>
  ): Promise<IReportingCategory> {
    const res = await axios.patch<IReportingCategory>(
      `${apiUrl(restaurantId)}/${id}`,
      input
    );
    return res.data;
  }

  /** Archives the category (and its children); live mappings are cleared. */
  static async remove(restaurantId: number, id: number): Promise<void> {
    await axios.delete(`${apiUrl(restaurantId)}/${id}`);
  }
}
